export const PLATFORMS = [
  { label: 'Google Ads', value: 'google_ads' },
  { label: 'Meta Ads', value: 'meta_ads' },
  { label: 'Yahoo!広告', value: 'yahoo_ads' },
  { label: 'X Ads', value: 'x_ads' },
  { label: 'TikTok Ads', value: 'tiktok_ads' },
  { label: 'LINE広告', value: 'line_ads' },
  { label: 'SmartNews Ads', value: 'smartnews_ads' },
  { label: 'Pinterest Ads', value: 'pinterest_ads' },
  { label: 'Apple Search Ads', value: 'apple_search_ads' },
];

export const PLATFORM_LABELS: Record<string, string> = {
  GOOGLE: 'Google広告',
  META: 'Meta広告',
  YAHOO: 'Yahoo広告',
  YAHOO_SEARCH: 'Yahoo!検索広告',
  YAHOO_DISPLAY: 'Yahoo!ディスプレイ広告',
};

export const ROLE_MAP: Record<string, string> = {
  advertiser: '広告主（自社商材の宣伝）',
  agency: '広告代理店（他社商材の宣伝）',
  production: '制作会社（Web、動画など）',
  other: 'その他・学生',
};

export const BUDGET_MAP: Record<string, string> = {
  none: '現在は出稿していない',
  under_10: '月額10万円未満',
  between_10_50: '月額10万円以上50万円未満',
  between_50_100: '月額50万円以上100万円未満',
  between_100_300: '月額100万円以上300万円未満',
  between_300_1000: '月額300万円以上1,000万円未満',
  over_1000: '月額1,000万円以上',
};

export const KNOWLEDGE_LEVEL_MAP: Record<string, string> = {
  beginner: '初心者（これから始める・用語がわからない）',
  intermediate: '中級者（管理画面の操作・基本的な分析ができる）',
  advanced: '上級者（高度な最適化・API活用などができる）',
};

export const AGENCY_NEEDS_MAP: Record<string, string> = {
  full_support: '運用代行を依頼したい',
  inhouse_support: 'インハウス化の支援・コンサルを依頼したい',
  tool_only: 'ツールのみ利用したい',
  other: 'その他',
};

export const HEARING_STATUS_MAP: Record<string, string> = {
  pending: '未対応',
  in_progress: '対応中',
  completed: '完了',
};

export const INQUIRY_STATUS_MAP: Record<string, string> = {
  unread: '未対応',
  in_progress: '対応中',
  resolved: '完了',
};

export const FUNNEL_STAGE_MAP: Record<string, string> = {
  pre_awareness: '認知前',
  awareness: '課題認知',
  research: '情報収集',
  comparison: '比較検討',
  conversion: 'コンバージョン',
  retargeting: '既存顧客',
};
